namespace GeniuzPOS.Purchase {
    export class PoCreditNoteColumns {
        static columnsKey = 'Purchase.PoCreditNote';
    }
}
